/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Open Software License (OSL 3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * http://opensource.org/licenses/osl-3.0.php
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   http://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from 'expose?$!expose?jQuery!jquery';
import 'expose?Tether!tether';
import 'bootstrap/dist/js/bootstrap.min';
import 'bootstrap-touchspin';
import 'snapsvg';

import '../css/theme';
import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';

import DropDown from './components/drop-down';
import Form from './components/form';
import MainMenu from './components/main-menu';
import ProductMinitature from './components/product-miniature';
import ProductSelect from './components/product-select';

import prestashop from 'prestashop';
import EventEmitter from 'events';

import './lib/bootstrap-filestyle.min';
import './lib/jquery.bxslider.min';
import './lib/jquery.cookie';
import './lib/15-jquery.total-storage.min';

import PhotoSwipe from './lib/photoswipe';
import PhotoSwipeUI_Default from './lib/photoswipe-ui-default';

import './components/block-cart';

// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

$(document).ready(() => {
  let dropDownEl = $('.js-dropdown');
  const form = new Form();
  let dropDown = new DropDown(dropDownEl);
  let productMinitature = new ProductMinitature();
  let productSelect  = new ProductSelect();
  let mainMenu = new MainMenu();
  dropDown.init();
  form.init();
  mainMenu.init();
  productMinitature.init();
  productSelect.init();
  $("#products").bind("DOMSubtreeModified", function() {
    productMinitature.init();
  });

  /* Toggle menu */
  var speed = 800,
    easing = mina.elastic,
    isMenuopend = false;
  var s = Snap("#svg");
  if (s) {
    var path = s.select( 'path' );
    var pathDefault = path.attr('d');
    var pathLeft = jQuery('.morph-shape').attr('data-morph-open');
    var pathRight = jQuery('.morph-shape').attr('data-morph-close');
  }

  jQuery('#main-sidebar .menu__handle').click(function() {
    jQuery(this).parent('#main-sidebar').toggleClass('menu--open').removeClass('keep-menu-state');
    if ($('#main-sidebar').hasClass('menu--open'))
      $.totalStorage('menuState', 'opened');
    else
      $.totalStorage('menuState', 'closed');
    path.stop().animate( { 'path' : isMenuopend ? pathLeft : pathRight }, 350, mina.easeout, function() {
      path.stop().animate( {'path' : pathDefault}, speed, easing);
    });
    isMenuopend = !isMenuopend;
  });

  if($(window).width()<=1024) {
    $('#main-sidebar').removeClass('menu--open menu-opened-default');
  } else {
    if ($('#main-sidebar').hasClass('keep-menu-state')) {
      //$('#main-sidebar').addClass('menu--open');

      if(localStorage.getItem('menuState')) {
        var menuState = localStorage.getItem('menuState');
        // console.log(menuState);
        if (menuState == '"opened"') {
          $('#main-sidebar').addClass('menu--open');
          // console.log('menu is supposed to be opened');
        } else {
          $('#main-sidebar').removeClass('menu--open');
          // console.log('menu is supposed to be closed');
        }
      }
    }
  };

  // carousel product page
  if (!!$.prototype.bxSlider)
    $('.page-product #main .jq_carousel, .cross-selling .jq_carousel').bxSlider({
      minSlides: 1,
      maxSlides: 4,
      slideWidth: 200,
      slideMargin: 15,
      pager: false,
      nextText: '',
      prevText: '',
      moveSlides:1,
      infiniteLoop:false,
      hideControlOnEnd: true
    });
  
  // carouel columns (vertical), in sidebar
  if (!!$.prototype.bxSlider) {
    $('.sidebar .jq_carousel').bxSlider({
      mode: 'vertical',
      slideMargin: 0,
      moveSlides:1,
      pager: false,
      auto: true,
      useCSS: false
    });
  }

  // photoswipe product page
  $('.images-container .product-images').each( function() {
    var $pic     = $(this),
      getItems = function() {
        var items = [];
        $pic.find('.thumb').each(function() {
          var $href   = $(this).data('image-large-src'),
            $size   = $(this).data('size').split('x'),
            $width  = $size[0],
            $height = $size[1];

          var item = {
            src : $href,
            w   : $width,
            h   : $height
          }

          items.push(item);
        });
        return items;
      }

    var items = getItems();

    var $pswp = $('.pswp')[0];
    $pic.on('click', '.thumb-container', function(event) {
      event.preventDefault();
       
      var $index = $(this).index();
      var options = {
          index: $index,
          bgOpacity: 0.7,
          showHideOpacity: true
      }
       
      // Initialize PhotoSwipe
      var lightBox = new PhotoSwipe($pswp, PhotoSwipeUI_Default, items, options);
      lightBox.init();
    });
  });

  NbCols();

  $(window).resize(function() {
    NbCols();
  });
});

var NbCols = function () {
  // count columns in content column
  jQuery('#content-wrapper').attr('data-nb-cols', Math.floor((jQuery('#content-wrapper').width() + 15) / 195));

  // count columns in footer
  jQuery('.footer-container > .container:first-child').attr('data-nb-cols', Math.floor((jQuery('.footer-container > .container:first-child').width() + 15) / 195));
}



// WEBPACK FOOTER //
// ./js/theme.js